import ApiModel               from '@widesk-core/models/ApiModel';
import { Action }             from '@widesk-ui/components/ButtonActions';
import { Modal }              from '@widesk-ui/components/modal/Modal';
import { ModalProps }         from '@widesk-ui/components/modal/Modal';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import { HistoryOutlined }    from '@ant-design/icons';
import StatusHistoryTableBox  from '@widesk-ui/components/StatusHistoryTableBox';
import React                  from 'react';

type SeeHistoryOptions = {
	modelName?: string;
	hideModelName?: boolean;
	modalProps?: Partial<ModalProps> | ((model: InstanceType<any>) => Partial<ModalProps>),
	actionProps?: Partial<Action>;
};

const actionSeeHistoryModel = <MC extends typeof ApiModel & WithLocalizedLabel>(
	model: ApiModel & WithLocalizedLabel,
	historyModelClass: MC,
	historyFilterName: ModelFilterName<InstanceType<MC>>,
	renderRightColumn: (m: InstanceType<MC>) => React.ReactNode,
	options?: SeeHistoryOptions,
): Action => {
	const label = `Voir l'historique` + (options?.hideModelName ? '' : ` - ${options?.modelName || model.localize()}`);
	const modalContent = (
		<StatusHistoryTableBox
			key={"e"}
			options={{
				variant: "borderless",
			}}
			modelClass={historyModelClass}
			renderRightColumn={renderRightColumn}
			onFetchCollectionStart={async coll => {
				return coll.setFilters({ [historyFilterName]: model.id } as ModelFilters<InstanceType<MC>>);
			}}
		/>
	);

	return {
		label,
		icon: <HistoryOutlined />,
		onClick: () => Modal.open({
			title: label,
			bodyPadding: 0,
			children: modalContent,
			...options?.modalProps,
		}),
		...options?.actionProps,
	};
};

export default actionSeeHistoryModel;
